import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }

import { computed, Ref, ref, toRef } from 'vue';
import Chip from 'primevue/chip';
import { useToast } from 'primevue/usetoast';
import { ClinicianInterface } from '@/types';
import { useStudentClinicianStore } from '@/store';
import { EMIT, PERMISSIONS } from '@/enum';
import { can, isValidForRoleByTenant } from '@/composables';
import AddPersonModal from '@/components/AddPersonModal/AddPersonModal.vue';

interface ClinicianPropsInterface {
  tableData?: ClinicianInterface[];
  studentId?: number | undefined;
  loading?: boolean;
}

interface ClinicianTableInterface {
  id: number;
  display_name: string;
  disciplines?: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentClinicianTable',
  props: {
    tableData: {},
    studentId: {},
    loading: { type: Boolean }
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const clinicianStudentStore = useStudentClinicianStore();
const clinicians: Ref<ClinicianInterface[] | undefined> = toRef(props, 'tableData');
const clinicianCount: Ref<number> = computed(() => (clinicians.value ? clinicians.value.length : 0));
const clinicianModalOpen = ref(false);
const toast = useToast();
const clinicianItems: Ref<{ name: string; value: number }[]> = ref([]);

const createMenuModel = (item: ClinicianTableInterface) => {
  const menuItem = {
    label: 'Remove service provider',
    command: () => {
      detachClinician([item.id], item.display_name);
    },
    visible: can([PERMISSIONS.STUDENT_DETACH_CLINICIANS]),
  };
  return [menuItem].filter((item) => item.visible);
};

const attachClinician: (ids: number[]) => Promise<void> = async (ids) => {
  await clinicianStudentStore.attachClinicians({
    clinicians: ids,
    studentId: props.studentId as number,
  });
  emit(EMIT.UPDATE);
  toast.add({
    severity: 'success',
    summary: 'Added',
    detail: 'Service Provider(s) has been added',
    life: 3000,
  });
};

const detachClinician: (id: number[], clinicianName: string) => Promise<void> = async (ids, clinicianName) => {
  await clinicianStudentStore.detachClinicians({ clinicians: ids, studentId: props.studentId as number });
  emit(EMIT.UPDATE);
  toast.add({
    severity: 'success',
    summary: 'Removed',
    detail: `Service Provider ${clinicianName} has been removed from student`,
    life: 3000,
  });
};

const openAddClinicians = async () => {
  if (can([PERMISSIONS.STUDENT_ATTACH_CLINICIANS]) && can([PERMISSIONS.STUDENT_CLINICIANS_AVAILABLE_TO_ADD])) {
    clinicianItems.value = await clinicianStudentStore.getAddCliniciansModalData(props.studentId as number);
    clinicianModalOpen.value = true;
  } else {
    toast.add({
      severity: 'warning',
      summary: 'Error',
      detail: 'You do not have permission to add service providers',
      life: 3000,
    });
  }
};

const onCancelAdd = () => (clinicianModalOpen.value = false);

const onSaveAdd = (clinicians: { name: string; value: number }[]) => {
  const cliniciansId = clinicians.map((clinicians) => clinicians.value);
  attachClinician(cliniciansId);
  clinicianModalOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Service Providers", -1)),
      _createVNode(_unref(Chip), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(clinicianCount.value), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).STUDENT_ATTACH_CLINICIANS]) && _unref(isValidForRoleByTenant)())
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              type: "text",
              size: "small",
              text: "Add Service Provider",
              "icon-left": "add",
              onClick: openAddClinicians
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: clinicians.value,
        "global-filter-fields": ['name'],
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: __props.loading,
        "data-key": "name",
        "responsive-layout": "scroll",
        "scroll-height": "440px",
        "state-key": "session-student-clinician-store-table",
        "state-storage": "session",
        class: _normalizeClass({ 'table-loading': __props.loading })
      }, {
        empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Service Providers not assigned", -1)
        ]))]),
        default: _withCtx(() => [
          (clinicianCount.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_Column, {
                  "body-class": "mw-20rem",
                  "header-class": "mw-20rem",
                  field: "name",
                  header: "Service Provider"
                }, {
                  body: _withCtx(({ data }) => [
                    (_unref(isValidForRoleByTenant)(data.people_type))
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 0,
                          to: `/user/${data.id}`,
                          class: "font-semibold",
                          textContent: _toDisplayString(data.full_name)
                        }, null, 8, ["to", "textContent"]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "font-semibold",
                          textContent: _toDisplayString(data.full_name)
                        }, null, 8, _hoisted_2))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "disciplines",
                  header: "Disciplines"
                }, {
                  body: _withCtx(({ data }) => [
                    (data.disciplines)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.disciplines, (discipline, index) => {
                            return (_openBlock(), _createElementBlock("span", { key: discipline }, [
                              _createElementVNode("span", null, _toDisplayString(discipline.name), 1),
                              (index < data.disciplines.length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, ", "))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  "body-style": "justify-content: center; max-width: 10rem;",
                  "header-style": "justify-content: center; max-width: 10rem",
                  field: "id",
                  header: "Actions"
                }, {
                  body: _withCtx(({ data }) => [
                    (createMenuModel(data).length > 0)
                      ? (_openBlock(), _createBlock(_component_ActionMenu, {
                          key: 0,
                          "menu-items": createMenuModel(data),
                          icon: "more_horiz"
                        }, null, 8, ["menu-items"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading", "class"]),
      (clinicianModalOpen.value && _unref(can)([_unref(PERMISSIONS).STUDENT_CLINICIANS_AVAILABLE_TO_ADD]) && _unref(isValidForRoleByTenant)())
        ? (_openBlock(), _createBlock(AddPersonModal, {
            key: 0,
            title: "Add Service Providers",
            items: clinicianItems.value,
            searchable: true,
            "button-text": "Add Service Providers",
            placeholder: "Search Service Providers",
            "person-type": "clinician",
            onAddItems: onSaveAdd,
            onCancel: onCancelAdd
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})